require('./viewing_operations.js');
require('./hoveringState.js');
require('./editingState.js');
require('./idleState.js');
require('./infoGatheringState.js');
require('./validatingState.js');
require('./resizing_canvas.js');

PegasusTemplate.StateMachine = Ember.StateManager.extend({
  initialize: function(){
    this.transitionTo('initializing');
  },

  didCancelUpload: function(manager){
    if ( manager.jqXHR ) {
      if ( manager.jqXHR.abort ) {
        manager.jqXHR.abort();
      }
      manager.set('jqXHR', null);
    }
  },

  addingRow: Em.State.extend({
    setup: function(){
      PegasusTemplate.lookupController('frameCommManager').send('addRow');
    },

    didSaveFragment: Em.K,

    didFinishEditing: function(manager){
      manager.send('didSave');
    },

    hover: function(manager, context){
      manager.transitionTo('hovering', context);
    }
  }),

  hoverRow: function(manager, row){
    if ( PegasusTemplate.lookupController('rowOperations').get('content') !== row ) {
      $('.popped-row').removeClass('popped-row');
      $('.selected-mirror-column').removeClass('selected-mirror-column');
      PegasusTemplate.lookupController('rowOperations').set('content', row);
    }
  },

  hideControls: Em.K,

  didChangeEditorContext: function(manager){
    var router = PegasusTemplate.lookupRouter();
    Em.run.cancelTimers();
    PegasusTemplate.featherEditor.close();
    router.send('clearPreview');
    PegasusTemplate.set('canvasInstance', null);
    this.clearObservers();
    Em.run.next( manager, 'initialize');
  },

  clearObservers: function(){
    this.observersForKey('currentPath').clear();
  },

  initializing: PegasusTemplate.InitializingState,
  saved: PegasusTemplate.BaseState.extend({
    didSave: function(){
      PegasusTemplate.stateMachine.transitionTo('idling');
    },
    hover: function(){
      PegasusTemplate.stateMachine.transitionTo('idling');
    }
  }),
  hovering: PegasusTemplate.HoveringState.extend(),
  idling: PegasusTemplate.IdlingState.extend(),
  editing: PegasusTemplate.EditingState.extend(),
  viewingOperations: PegasusTemplate.ViewingOperationsState.extend(),
  validating: PegasusTemplate.ValidatingState.extend(),
  infoGathering: PegasusTemplate.InfoGatheringState.extend(),
  resizingCanvas: PegasusTemplate.ResizingCanvasState.extend(),
  editHeader: function(manager, context){
    manager.transitionTo( 'editing.header', context );
  },
  editPalette: function(manager, context){
    var template = PegasusTemplate.loadedTemplate();
    var paletteType = template.get('paletteType').camelize();
    manager.transitionTo('editing.' + paletteType);
  },
  closeModal: function(){
    PegasusTemplate.lookupController('modal').setProperties({
      presenter: null
    });
  },
  didValidDrop: Ember.K,
  didSave: function(){
    PegasusTemplate.stateMachine.transitionTo('saved');
  },
  didFinishEditing: function(){
    this.didSave();
    //PegasusTemplate.lookupController('rowOperations').set('content', null);
  },
  mirrorRow: function(manager, mirrorCapable) {
    var rowOps = PegasusTemplate.lookupController('rowOperations');
    var position = PegasusTemplate.blockRegionInstance.indexOf( rowOps.get('content') );

    if ( manager.get('currentState.isEditing') ) {
      PegasusTemplate.Helpers.addOneTimeObserver(manager, 'currentPath', 'saved', function(){
        Em.run.scheduleOnce('afterRender', rowOps, function(){
          this.set('content', PegasusTemplate.blockRegionInstance.objectAt(position) );
          Em.run.scheduleOnce('afterRender',  rowOps, 'mirrorRow', null, mirrorCapable);
          manager.transitionTo('idling');
        });
      });
      manager.send('didSave');
      return;
    }

    PegasusTemplate.lookupController('rowOperations').mirrorRow(null, mirrorCapable);
  }
});

PegasusTemplate.StateMachine.reopen({
  transitionTo: function(state, context){
    var result = this._super.apply(this, arguments);
    Em.set( 'PegasusTemplate.subStatus', state.camelize() );
    return result;
  }
});
